"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandButtonRow = void 0;
const react_1 = __importDefault(require("react"));
const key_tag_1 = require("./key-tag");
exports.CommandButtonRow = (_a) => {
    var { children, shortCut } = _a, props = __rest(_a, ["children", "shortCut"]);
    return (react_1.default.createElement("button", Object.assign({ type: "button" }, props, { className: "command-palette-row" }),
        react_1.default.createElement("span", { className: "command-name" }, children),
        react_1.default.createElement("span", null, shortCut &&
            shortCut.map((shortcut) => (react_1.default.createElement(key_tag_1.KeyTag, { mini: true, key: shortcut }, shortcut))))));
};
//# sourceMappingURL=command-button-row.js.map